import React, { useState, useRef, useEffect } from "react";
import { useFunds } from "../service";

export const Exchange = () => {
  const divRef = useRef(null);
  const [account, setAccount] = useState("Main Account");
  const [macAccount, setmacAccount] = useState("MAC Account");
  const [idNumber, setIdNumber] = useState("");
  const [fromType, setfromType] = useState("USD");
  const [toType, settoType] = useState("MAC");
  const [amount, setAmount] = useState("");
  const [fromDropdownName, setfromDropdownName] = useState("$USD");
  const [toDropdownName, settoDropdownName] = useState("$MAC");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [errors, setErrors] = useState({
    idNumber: false,
    amount: false,
    acceptedTerms: false,
  });

  const { withdrawFunds } = useFunds();

  useEffect(() => {
    const preventScroll = (event) => {
      event.preventDefault();
    };

    const div = divRef.current;
    if (div) {
      div.addEventListener("wheel", preventScroll, { passive: false });
    }

    return () => {
      if (div) {
        div.removeEventListener("wheel", preventScroll);
      }
    };
  }, []);
  const handle = () => {
    let newErrors = {
      idNumber: !idNumber,
      amount: !amount,
      acceptedTerms: !acceptedTerms,
    };

    setErrors(newErrors);

    if (newErrors.idNumber || newErrors.amount || newErrors.acceptedTerms) {
      return;
    }

    withdrawFunds.mutate(idNumber, amount);
    setIdNumber("0");
    setAmount("0");
    setAcceptedTerms(false);

    const modalCloseButton = document.querySelector(
      "#menu-exchange .btn-close"
    );
    if (modalCloseButton) {
      modalCloseButton.click();
    }
  };

  const validate = () => {
    let newErrors = {};
    if (!idNumber) newErrors.idNumber = true;
    if (!amount) newErrors.amount = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleExchange = () => {
    // if (!validate()) return;
    setAccount("Main Account");
    setIdNumber("");
    setAmount("");
    ModalClose();
  };

  const ModalClose = () => {
    const modalCloseButton = document.querySelector(
      "#menu-exchange .btn-close"
    );
    if (modalCloseButton) {
      modalCloseButton.click();
    }
  };

  const handleInputChange = (setter, field) => (e) => {
    setter(e.target.value);
    setErrors((prev) => ({ ...prev, [field]: false }));
  };

  return (
    <div
      ref={divRef}
      className="offcanvas offcanvas-top rounded-m"
      id="menu-exchange"
      style={{ height: "100vh", background: "#141414", padding: "30px 18px" }}
    >
      <div className="offcanvas-header">
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          style={{ display: "none" }}
        ></button>
        <img
          onClick={ModalClose}
          style={{
            cursor: "pointer",
            marginLeft: "-5px",
            marginRight: "10px",
            marginTop: "-10px",
            backgroundColor: "255, 0, 0",
            zIndex: "1",
          }}
          src="./images/store/modal_close.png"
        />
        <h5
          className="offcanvas-title font-25 font-700"
          id="menuTransferLabel"
          style={{ marginTop: "-10px" }}
        >
          Exchange Funds
        </h5>
      </div>
      <div style={{ paddingTop: "20px" }}>
        <label className="font-11 font-700 pt-2" style={{ color: "#797373" }}>
          Choose Account
        </label>
        <div
          className="form-custom form-icon"
          style={{ background: "#1E1E1E" }}
        >
          <i>
            <img src="./images/store/modal_account.png" alt="account" />
          </i>
          <>
            <style>{`
              .custom-select {
                padding-left:0px;
                background-color: #1E1E1E;
                color: white !important;
                font-size: 15px !important;
              }
              .form-select {
                font-size: 15px !important;
              }

              .custom-select option {
                background-color: #1E1E1E !important;
                color: white !important;
                font-size: 15px !important;
              }

              .form-select option {
                font-size: 15px !important;
              }
            `}</style>
            <select
              className="form-select rounded-xs custom-select"
              value={account}
              onChange={(e) => setAccount(e.target.value)}
              style={{
                backgroundColor: "black",
                color: "white",
                height: "72.8px",
              }}
              onFocus={(e) => e.target.classList.add("custom-select")}
              onBlur={(e) => e.target.classList.remove("custom-select")}
            >
              <option value="Main Account">Main Account</option>
              <option value="Savings Account">Savings Account</option>
              <option value="Company Account">Company Account</option>
            </select>
          </>
        </div>
        <label className="font-11 font-700 pt-2" style={{ color: "#797373" }}>
          Choose Account
        </label>
        <div
          className="form-custom form-icon"
          style={{ background: "#1E1E1E" }}
        >
          <i>
            <img src="./images/store/modal_mac.png" alt="account" />
          </i>
          <>
            <style>{`
              .custom-select {
                padding-left:0px;
                background-color: #1E1E1E;
                color: white !important;
                font-size: 15px !important;
              }
              .form-select {
                font-size: 15px !important;
              }

              .custom-select option {
                background-color: #1E1E1E !important;
                color: white !important;
                font-size: 15px !important;
              }

              .form-select option {
                font-size: 15px !important;
              }
            `}</style>

            <select
              className="form-select rounded-xs custom-select"
              value={macAccount}
              onChange={(e) => setmacAccount(e.target.value)}
              style={{
                backgroundColor: "black",
                color: "white",
                height: "72.8px",
              }}
              onFocus={(e) => e.target.classList.add("custom-select")}
              onBlur={(e) => e.target.classList.remove("custom-select")}
            >
              <option value="Mac Account">Mac Account</option>
              <option value="Savings Account">Savings Account</option>
              <option value="Company Account">Company Account</option>
            </select>
          </>
        </div>
        <div
          className="form-icon rounded-xs"
          style={{
            background: "#1E1E1E",
            marginTop: "20px",
            paddingBottom: "15px",
          }}
        >
          <div>
            <div className="d-flex justify-content-between">
              <label
                className="font-11 font-700"
                style={{
                  color: "#797373",
                  marginTop: "5px",
                  marginLeft: "20px",
                }}
              >
                From
              </label>
              <label
                className="font-11 font-700"
                style={{
                  color: "#797373",
                  marginTop: "5px",
                  marginRight: "15px",
                }}
              >
                Available 200.57957 USD
              </label>
            </div>
            <div
              className="d-flex justify-content-between"
              style={{ color: "#797373", marginTop: "15px" }}
            >
              <div
                className="dropdown"
                style={{ color: "#797373", marginLeft: "13px", color: "white" }}
              >
                <button
                  className="btn dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ color: "white" }}
                >
                  {fromDropdownName}
                </button>
                <ul
                  className="dropdown-menu"
                  style={{ backgroundColor: "#1E1E1E" }}
                >
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setfromType("$USD");
                        setfromDropdownName("$USD");
                        settoDropdownName("$MAC");
                      }}
                      style={{
                        color: "white",
                        backgroundColor: "#1E1E1E",
                        textDecoration: "none",
                      }}
                    >
                      $USD
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setfromType("$MAC");
                        setfromDropdownName("$MAC");
                        settoDropdownName("$USD");
                      }}
                      style={{
                        color: "white",
                        backgroundColor: "#1E1E1E",
                        textDecoration: "none",
                      }}
                    >
                      $MAC
                    </a>
                  </li>
                </ul>
              </div>
              <div style={{ width: "50%", marginTop: "5px" }}>
                <input
                  type="number"
                  style={{
                    color: "#797373",
                    border: "none",
                    fontSize: "11px",
                    borderBottom: "1px solid #797373",
                    background: "none",
                    textAlign: "center",
                  }}
                  value={amount}
                  onChange={handleInputChange(setAmount, "amount")}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "-10px",
            marginBottom: "-20px",
            position: "relative",
            zIndex: "10",
          }}
        >
          <i>
            <img src="./images/store/modal_exchange.png" alt="account" />
          </i>
        </div>
        <div
          className="form-icon rounded-xs"
          style={{
            background: "#1E1E1E",
            marginTop: "10px",
            paddingBottom: "15px",
          }}
        >
          <div>
            <div className="d-flex justify-content-between">
              <label
                className="font-11 font-700"
                style={{
                  color: "#797373",
                  marginTop: "5px",
                  marginLeft: "20px",
                }}
              >
                To
              </label>
              <label
                className="font-11 font-700"
                style={{
                  color: "#797373",
                  marginTop: "5px",
                  marginRight: "15px",
                }}
              >
                Available 200.57957 USD
              </label>
            </div>
            <div
              className="d-flex justify-content-between"
              style={{ color: "#797373", marginTop: "15px" }}
            >
              <div
                className="dropdown"
                style={{ color: "#797373", marginLeft: "13px", color: "white" }}
              >
                <button
                  className="btn dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ color: "white" }}
                >
                  {toDropdownName}
                </button>
                <ul
                  className="dropdown-menu"
                  style={{ backgroundColor: "#1E1E1E" }}
                >
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        settoType("$USD");
                        settoDropdownName("$USD");
                        setfromDropdownName("$MAC");
                      }}
                      style={{
                        color: "white",
                        backgroundColor: "#1E1E1E",
                        textDecoration: "none",
                      }}
                    >
                      $USD
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        settoType("$MAC");
                        settoDropdownName("$MAC");
                        setfromDropdownName("$USD");
                      }}
                      style={{
                        color: "white",
                        backgroundColor: "#1E1E1E",
                        textDecoration: "none",
                      }}
                    >
                      $MAC
                    </a>
                  </li>
                </ul>
              </div>
              <div
                style={{ width: "50%", textAlign: "center", height: "100%" }}
              >
                <label
                  type="number"
                  style={{
                    color: "#797373",
                    border: "none",
                    marginTop: "5px",
                    fontSize: "12px",
                  }}
                  value={amount}
                  onChange={handleInputChange(setAmount, "amount")}
                >
                  {amount}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div
          className="text-center"
          style={{
            position: "absolute",
            bottom: "25px",
          }}
        >
          <button
            onClick={handleExchange}
            className="btn"
            style={{
              height: "62px",
              width: "342px",
              background: "#2E2CB2",
              color: "#FFFFFF",
              marginTop: "50px",
              borderRadius: "25px",
            }}
          >
            Exchange
          </button>
        </div>
      </div>
    </div>
  );
};
